import { ApiResource } from '../api-resource';
import { MessageChannel } from '../message-channel/message-channel.model';
import { Schedule } from '../_lib/schedule';
import { Endpoint } from '../api.decorators';

@Endpoint('periods', 'Period')
export class Period extends ApiResource<Period> {
  schedule!: Schedule;
  label!: string;
  year!: number;
  week!: number;
  start!: Date;
  end!: Date;
  name!: string;
  headMonitorChannel?: MessageChannel;

  override toLabel(): string {
    return `${this.label} ${this.week} - ${this.year}`;
  }
}
